import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'store/hooks'
import { openSnackbar } from 'store/modules/snackbar/actions'
import {
  getItemFormLocalStorageSelector,
  IS_SUCCESS_PASSWORD_CHANGE,
  removeDataFromLocalStorage,
} from 'utils/localStorage'

export default function usePasswordChangedNotification() {
  const dispatch = useAppDispatch()
  const isPasswordChangedFromLS = useAppSelector((state) =>
    getItemFormLocalStorageSelector(state, IS_SUCCESS_PASSWORD_CHANGE, false),
  )

  useEffect(() => {
    if (isPasswordChangedFromLS) {
      dispatch(
        openSnackbar({
          message: 'Password changed successfully. Please login again',
          variant: 'success',
        }),
      )
      dispatch(removeDataFromLocalStorage(IS_SUCCESS_PASSWORD_CHANGE, false))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
